import { SiteSizeVsCostPerSFChartUnwrapped } from '../../../components/SiteValueCharts/SiteSizeVsCostPerSFChart.tsx';
import { Tkv2SiteValueChartsParams } from '../../referenceView/utils/useTkv2SiteValueChartsParams.ts';
import { IMAGE_FACTOR, PNG_HEIGHT, PNG_WIDTH } from './constants.ts';
import { pngChartMaker } from './pngChartMaker.tsx';

export const pngSiteSizeToCostPerSFChartMaker = async ({
  siteSizeVsPriceChartData,
}: Tkv2SiteValueChartsParams): Promise<string | undefined> =>
  pngChartMaker(SiteSizeVsCostPerSFChartUnwrapped, {
    data: siteSizeVsPriceChartData,
    disableAnimations: true,
    width: PNG_WIDTH * IMAGE_FACTOR,
    height: PNG_HEIGHT * IMAGE_FACTOR,
  });
